import type { EventName } from "@lit/react";
import { Tabs as TabsElement, type TabsEventMap as _TabsEventMap, } from "@vaadin/tabs/vaadin-tabs.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TabsElement, };
export type TabsEventMap = Readonly<{
    onSelectedChanged: EventName<_TabsEventMap["selected-changed"]>;
    onItemsChanged: EventName<_TabsEventMap["items-changed"]>;
}>;
const events = { onSelectedChanged: "selected-changed", onItemsChanged: "items-changed" } as TabsEventMap;
export type TabsProps = WebComponentProps<TabsElement, TabsEventMap>;
export const Tabs = createComponent({
    elementClass: TabsElement, events, react: React, tagName: "vaadin-tabs"
});
